<template>
  <div>
    <div class="container">
      <el-tooltip content="广州市职业教育与终身教育学会" placement="bottom" effect="light">
        <img src="/image/headerpic2.png" class="img0" alt />
      </el-tooltip>
      <el-tooltip content="广州市职业教育与终身教育学会" placement="bottom" effect="light">
        <img
          src="/image/headText0.png"
          class="headText0"
          @click="goHome()"
          alt
        />
        <!-- <img
          :src="$route.path == '/home'?'/image/headText0.png':'/image/headText01.png'"
          class="headText0"
          @click="goHome()"
          alt
        /> -->
        <!-- <div
          @click="goHome()"
          class="box1"
          :style="$route.path == '/home'?'color:#ffffff;':'color:#104584;'"
        >
          <p class="p1">广州市职业教育与终身教育学会</p>
          <p class="p2">GuangZhou Vocational and lifelong education association</p>
        </div>-->
      </el-tooltip>

      <div class="box2">
        <!-- <input type="search" /> -->
        <!-- <img src="./image/search.png" alt=""> -->
        <div class="searchForm">
          <input type="text" v-model="keyword" @keydown.enter="goSearch()" />
          <!-- 编程式导航:因为有业务 -->
          <img src="/image/search.png" @click="goSearch()" />
        </div>
      </div>
    </div>
    <!-- <div class="container-box">
      <img src="/image/headText.png" class="headText" alt />
    </div>-->
  </div>
</template>

<script>
export default {
  //给组件起一个名字,开发者工具中显示这个组件的时候，显示的就是这个名字
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  data() {
    return {
      //收集用户输入的关键字
      keyword: ""
    };
  },

  methods: {
    goSearch() {
      this.$router.push({
        name: "search",
        // params: { title: this.keyword || undefined },
        query: { title: this.keyword || "" }
      });
    },
    goHome() {
      if (this.$route.path === "/home") {
        // 检查当前是否在首页
        this.$router.go(); // 刷新页面
      } else {
        this.$router.push("/home"); // 如果不在首页，跳转到首页
      }
    }
  }
};
</script>

<style scoped lang="less">
// .container-box {
//   width: 1200px;
//   margin: 0 auto;
//   .headText {
//     margin: 11px 75px 26px 75px;
//     width: 1050px;
//     height: 54px;
//   }
// }
.container {
  width: 1200px;
  height: 109px;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 36px;
  display: flex;
  .img0 {
    width: 109px;
    height: 109px;
    cursor: pointer;
  }
  .headText0 {
    margin: 12px 0px 15px 12px;
    width: 650px;
    height: 81px;
    cursor: pointer;
  }
  // .box1 {
  //   height: 100%;
  //   margin-left: 18px;
  //   cursor: pointer;
  //   .p1 {
  //     padding-top: 10px;
  //     font-size: 36px;
  //     font-family: FZCSJW--GB1-0, FZCSJW--GB1;
  //     font-weight: normal;
  //     letter-spacing: 3px;
  //   }
  //   .p2 {
  //     margin-top: 16px;
  //     font-size: 20px;
  //     font-family: PingFangSC-Semibold, PingFang SC;
  //     font-weight: 600;
  //     // color: #ffffff;
  //     letter-spacing: 2px;
  //   }
  //   &:hover {
  //     text-decoration: none;
  //   }
  // }
  .box2 {
    width: 368px;
    height: 48px;
    margin-left: 56px;
    margin-top: 31px;
    box-shadow: 0px 2px 4px 0px rgba(98, 115, 197, 0.3);
    border-radius: 2px;
    display: flex;
    .searchForm {
      overflow: hidden;
      width: 100%;
      background: #fff;
      input {
        width: 314px;
        height: 48px;
        padding: 0px 4px;
        border: none;
        float: left;

        &:focus {
          outline: none;
        }
      }

      img {
        height: 16px;
        width: 16px;

        margin-left: 10px;
        margin-top: 18px;
        float: left;
        cursor: pointer;

        &:focus {
          outline: none;
        }
      }
    }
  }
}

@media only screen and (min-width: 993px) {
  //   .container-box {
  //   width: 1200px;
  //   margin: 0 auto;
  //   .headText {
  //     margin: 11px 75px 26px 75px;
  //     width: 1050px;
  //     height: 54px;
  //   }
  // }
  .container {
    width: 1200px;
    height: 109px;
    margin: 0 auto;
    padding-top: 100px;
    padding-bottom: 36px;
    display: flex;
    .img0 {
      width: 109px;
      height: 109px;
      cursor: pointer;
    }
    .headText0 {
      margin: 12px 0px 15px 12px;
      width: 650px;
      height: 81px;
      cursor: pointer;
    }
    // .box1 {
    //   height: 100%;
    //   margin-left: 18px;
    //   .p1 {
    //     padding-top: 10px;
    //     font-size: 36px;
    //     font-family: FZCSJW--GB1-0, FZCSJW--GB1;
    //     font-weight: normal;
    //     letter-spacing: 3px;
    //   }
    //   .p2 {
    //     margin-top: 16px;
    //     font-size: 20px;
    //     font-family: PingFangSC-Semibold, PingFang SC;
    //     font-weight: 600;
    //     // color: #ffffff;
    //     letter-spacing: 2px;
    //   }
    //   &:hover {
    //     text-decoration: none;
    //   }
    // }
    .box2 {
      width: 368px;
      height: 48px;
      margin-left: 56px;
      margin-top: 31px;
      box-shadow: 0px 2px 4px 0px rgba(98, 115, 197, 0.3);
      border-radius: 2px;
      display: flex;
      .searchForm {
        overflow: hidden;
        width: 100%;
        background: #fff;
        input {
          width: 314px;
          height: 48px;
          padding: 0px 4px;
          border: none;
          float: left;

          &:focus {
            outline: none;
          }
        }

        img {
          height: 16px;
          width: 16px;

          margin-left: 10px;
          margin-top: 18px;
          float: left;
          cursor: pointer;

          &:focus {
            outline: none;
          }
        }
      }
    }
  }
}
</style>
